export function showTips(msg, timeout = 2000) {
  let tipsDom = getTipsDom(msg);
  var parentElement = document.body;
  parentElement.appendChild(tipsDom);
  setTimeout(() => {
    parentElement.removeChild(tipsDom);
  }, timeout);
}

function getTipsDom(msg) {
  const cssStr =
    '#main-tips { position: fixed;z-index: 9999;    line-height: 30px; padding: 0 40px;text-align: center; display: block;justify-content: center;height: 30px; background: #333; color: #fff; opacity: 0.7; top: 50%; left: 50%;transform: translateX(-50%);border-radius: 5px; }';
  const tipstyle = document.createElement('style');
  tipstyle.attributes.style = 'text/css';
  tipstyle.textContent = cssStr;
  document.head.appendChild(tipstyle);
  let divElement = document.createElement('div');
  divElement.id = 'main-tips';
  divElement.innerHTML = msg;
  return divElement;
}
export function getCookie(name) {
  if (document.cookie.length > 0) {
    var start = document.cookie.indexOf(name + '=');
    if (start !== -1) {
      start = start + name.length + 1;
      var end = document.cookie.indexOf(';', start);
      if (end === -1) end = document.cookie.length;
      return decodeURI(document.cookie.substring(start, end));
    }
  }
  return '';
}

export function toGate(url = '/v/vcommon/home') {
  location.replace(location.origin + '/v/gate.html?url=' + encodeURIComponent(location.origin + url));
}

export function isUAT() {
    return (
        window.location.host.indexOf("-uat") != -1 ||
        window.location.host.indexOf("-dev") != -1 ||
        window.location.host.indexOf("localhost") != -1 ||
        window.location.host.indexOf("192.168") != -1
    );
  }